// extracted by mini-css-extract-plugin
export default {"customDatesLabel":"gklrKS"};